import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { BannerHelper } from './BannerHelper';
import { IBanner } from './BannerTypes';

import styles from './VbVideoBanners.module.less';

@Component({
	selector: 'vb-video-banners',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<div [ngClass]="[styles.root, isSmallSizePlayer ? styles.smallSizePlayer : '']">
			@for (banner of bannerHelper.bannerDetails().banners; track banner) {
				@if (banner.isEnabled  && banner.pushMethod === 'Manual' && bannerHelper.closedBannerIds().indexOf(banner.id) === -1){
					<div [ngClass]="styles.bannerWrapper">
						<div [ngClass]="styles.closeBtnWrapper">
							<button
								type="button"
								class="btn float-right btn-transparent"
								[attr.aria-label]="translations.close"
								(click)="onCloseClick(banner)"
							>
								<span class="vb-icon vb-icon-close"></span>
							</button>
						</div>
						@if (banner.message) {
							<div [ngClass]="styles.message" [innerHTML]="banner.message"></div>
						}
						@if (banner.link) {
							<div [ngClass]="styles.linkWrapper">
								<a [ngClass]="styles.link" [href]="banner.link" target="_blank">{{ banner.link }}</a>
							</div>
						}
					</div>
				}
			}
		</div>
	`,
    standalone: false
})
export class VbVideoBannersComponent {
	@Input() public isSmallSizePlayer: boolean;
	@Input() public bannerHelper: BannerHelper;
	@Input() public translations: any;

	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent
	) { }

	public onCloseClick(banner: IBanner): void {
		this.bannerHelper.closeBanner(banner);
	}
}
